export const GET_UPLOAD_ERRORS_REQUEST = "GET_UPLOAD_ERRORS_REQUEST";
export const GET_UPLOAD_ERRORS_SUCCESS = "GET_UPLOAD_ERRORS_SUCCESS";
export const GET_UPLOAD_ERRORS_FAILURE = "GET_UPLOAD_ERRORS_FAILURE";